import type { TFunction } from 'i18next';

/**
 * A CADE Tribunal model scope in words.
 *
 * The ETL writes a scope as `<REGIME>:<CASE TYPE>` (`LAW_12529_2011:CONDUCT`)
 * or `overall`, and the panels printed that key verbatim. The row KEY keeps the
 * ETL's string (links and exports re-read it); only the label is translated.
 * A code the locale does not name falls back to itself with underscores opened
 * up, so a new ETL scope is readable-if-plain rather than blank.
 */
export function cadeScopeLabel(scope: string, t: TFunction): string {
  if (scope === 'overall') return t('cade:conselheiro.conselho.overall');
  const [regime, type] = scope.includes(':') ? scope.split(':', 2) : [null, scope];
  const typeLabel = t(`cade:conselho.scopes.types.${type}`, { defaultValue: type.replace(/_/g, ' ').toLowerCase() });
  if (!regime) return typeLabel;
  const regimeLabel = t(`cade:conselho.scopes.regimes.${regime}`, { defaultValue: regime.replace(/_/g, ' ') });
  return `${typeLabel} (${regimeLabel})`;
}
